export default __webpack_public_path__ + "static/media/19-large.f0af7786.jpg";